module.exports = __webpack_public_path__ + "static/img/qrcode.c2907007.png";